export interface BlacklistsState {
    blacklists: BlacklistItem[]
    blacklistItem?: BlacklistItem
    blacklistContacts: BlacklistContactItem[]
    blacklistContactItem?: BlacklistContactItem
}

export interface BlacklistFilter {
    name?: string,
}

export interface BlacklistItem {
    blackListId?: number,
    id?: number,
    create_date?: string,
    name?: string,
    comment?: string,
    contacts?: number,
}

export interface BlacklistContactItem {
    id?: number,
    create_date?: string,
    msisdn?: string,
    email?: string,
    description?: string,
}

export class BlacklistContactsFilter {
    blackListId?: string = undefined
    msisdn?: string = undefined
    email?: string = undefined
    page_number?: number = 1

    constructor(blackListId: string) {
        this.blackListId = blackListId
    }
}

export class BlacklistImportRequest {
    blackListId: number|null = null
    fileName: string|null = null
    file: string|null = null
    separator: string = ','
    deleteMsisdnDuplicates: boolean = true
    deleteEmailDuplicates: boolean = true
    fieldSequence: Array<string> = []

    constructor(blackListId: number) {
        this.blackListId = blackListId
    }
}
